import { LOCALE_ID, NgModule, Injector } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { BrowserModule } from '@angular/platform-browser';
import { createCustomElement } from '@angular/elements';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule, NgItemLabelDirective } from '@ng-select/ng-select';
import { DatePipe } from '@angular/common';
import { IguauSelectComponent } from './comun/iguau-select/iguau-select.component';
import { BannerBlogComponent } from './banner-blog/banner-blog.component';
import { ComoFuncionaComponent } from './como-funciona/como-funciona.component';
import { BannerHomeAcceso, BannerHomeComponent } from './banner-home/banner-home.component';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { environment } from '../environments/environment';
import { FirstWordPipe } from './comun/pipes/first-word.pipe';
import { TruncatePipe } from './comun/pipes/truncate.pipe';
import { LimitarTextoPipe } from './comun/pipes/limitar-texto.pipe';
import { CuandoFechasPipe } from './comun/pipes/cuando-fechas.pipe';
import { LoaderComponent } from './comun/loader/loader.component';
import { HuellasModalComponent } from './modales/huellas-modal/huellas-modal.component';
import { VisitasModalComponent } from './modales/visitas-modal/visitas-modal.component';
import { QuizasConozcasComponent } from './quizas-conozcas/quizas-conozcas.component';
import { AmigosComponent } from './amigos/amigos.component';
import { UltimosPerfilesComponent } from './ultimos-perfiles/ultimos-perfiles.component';
import { BotonesHomeComponent } from './botones-home/botones-home.component';
import { PaseoInfoComponent } from './paseos/paseo-info/paseo-info.component';
import { PaseoDetallesComponent } from './paseos/paseo-detalles/paseo-detalles.component';
import { CalendarioComponent } from './comun/calendario/calendario.component';
import { PaseosComponent } from './paseos/paseos.component';
import { LeerMasComponent } from './comun/leer-mas/leer-mas.component';
import { PaseoComponent } from './paseos/paseo/paseo.component';
import { NeweditComponent } from './paseos/newedit/newedit.component';
import { AutoResizeDirective } from './comun/directives/auto-resize.directive';
import { AutoResizeDivDirective } from './comun/directives/auto-resize-div.directive';
import { MaxCharsDirective } from './comun/directives/max-chars.directive';
import { CarouselComponent } from './comun/carousel/carousel.component';
import { MurosComponent } from './muros/muros.component';
import { MuroComponent } from './muros/muro/muro.component';
import { MuroAccionesComponent } from './muros/muro-acciones/muro-acciones.component';
import { MuroPerfilComponent } from './muros/muro-perfil/muro-perfil.component';
import { PerfilComponent } from './perfil/perfil.component';
import { PerfilAccionesComponent } from './perfil/perfil-acciones/perfil-acciones.component';
import { PerfilShowComponent } from './perfil/perfil-show/perfil-show.component';
import { PerfilEditComponent } from './perfil/perfil-edit/perfil-edit.component';
import { PerfilHablamosComponent } from './perfil/perfil-hablamos/perfil-hablamos.component';
import { PerfilAdminComponent } from './perfil/perfil-admin/perfil-admin.component';
import { MensajesModalComponent } from './modales/mensajes-modal/mensajes-modal.component';
import { PerfilMensajeComponent } from './modales/mensajes-modal/perfil-mensaje/perfil-mensaje.component';
import { AmigosModalComponent } from './modales/amigos-modal/amigos-modal.component';
import { MascotasComponent } from './mascotas/mascotas.component';
import { MascotaShowComponent } from './mascotas/mascota-show/mascota-show.component';
import { MascotaEditComponent } from './mascotas/mascota-edit/mascota-edit.component';
import { PerfilOpcionesComponent } from './perfil/perfil-opciones/perfil-opciones.component';
import { CompartirModalComponent } from './modales/compartir-modal/compartir-modal.component';
import { NotificacionesModalComponent } from './modales/notificaciones-modal/notificaciones-modal.component';
import { PerfilPublicoComponent } from './perfil/perfil-publico/perfil-publico.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { HeaderMenuComponent } from './header/header-menu/header-menu.component';
import { HeaderMenuMiniComponent } from './header/header-menu-mini/header-menu-mini.component';
import { HeaderBuscarComponent } from './header/header-buscar/header-buscar.component';
import { HeaderLogoComponent } from './header/header-logo/header-logo.component';
import { HeaderTopComponent } from './header/header-top/header-top.component';
import { HeaderUserComponent } from './header/header-user/header-user.component';
import { RadarComponent } from './radar/radar.component';
import { SaludComponent } from './salud/salud.component';
import { MascotaFotosComponent } from './mascotas/mascota-edit/mascota-fotos/mascota-fotos.component';
import { FormatoHoraPipe } from './comun/pipes/formato-hora.pipe';
import { RelativeDatePipe } from './comun/pipes/relative-date.pipe';
import { SmartDatePipe } from './comun/pipes/smart-date.pipe';
import { MuroFiltrosComponent } from './muros/muro-filtros/muro-filtros.component';
import { AutofocusDirective } from './comun/directives/autofocus.directive';
import { InlineEditComponent } from './comun/inline-edit/inline-edit.component';
import { LoginComponent } from './user/login/login.component';
import { RegisterComponent } from './user/register/register.component';
import { RememberComponent } from './user/remember/remember.component';
import { RegenerateComponent } from './user/regenerate/regenerate.component';
import { IguauAccesosComponent } from './iguau-accesos/iguau-accesos.component';
import { FotosPrivadasComponent } from './perfil/fotos-privadas/fotos-privadas.component';

registerLocaleData(localeEs, 'es');

@NgModule({
  declarations: [
    FirstWordPipe,
    TruncatePipe,
    LimitarTextoPipe,
    CuandoFechasPipe,
    LoaderComponent,
    IguauSelectComponent,
    HuellasModalComponent,
    VisitasModalComponent,
    QuizasConozcasComponent,
    AmigosComponent,
    UltimosPerfilesComponent,
    BotonesHomeComponent,
    PaseoInfoComponent,
    PaseoDetallesComponent,
    CalendarioComponent,
    PaseosComponent,
    LeerMasComponent,
    PaseoComponent,
    NeweditComponent,
    AutoResizeDirective,
    AutoResizeDivDirective,
    MaxCharsDirective,
    CarouselComponent,
    MurosComponent,
    MuroComponent,
    MuroAccionesComponent,
    MuroPerfilComponent,
    PerfilComponent,
    PerfilAccionesComponent,
    PerfilShowComponent,
    PerfilEditComponent,
    PerfilHablamosComponent,
    PerfilAdminComponent,
    MensajesModalComponent,
    PerfilMensajeComponent,
    AmigosModalComponent,
    MascotasComponent,
    MascotaShowComponent,
    MascotaEditComponent,
    PerfilOpcionesComponent,
    CompartirModalComponent,
    NotificacionesModalComponent,
    PerfilPublicoComponent,
    FooterComponent,
    HeaderComponent,
    HeaderMenuComponent,
    HeaderMenuMiniComponent,
    HeaderBuscarComponent,
    HeaderLogoComponent,
    HeaderTopComponent,
    HeaderUserComponent,
    RadarComponent,
    SaludComponent,
    MascotaFotosComponent,
    FormatoHoraPipe,
    RelativeDatePipe,
    SmartDatePipe,
    MuroFiltrosComponent,
    AutofocusDirective,
    InlineEditComponent,
    LoginComponent,
    RegisterComponent,
    RememberComponent,
    RegenerateComponent,
    IguauAccesosComponent,
    BannerBlogComponent,
    ComoFuncionaComponent,
    BannerHomeComponent,
    FotosPrivadasComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgSelectModule,
    ToastrModule.forRoot({
        timeOut: 3000,
        positionClass: 'toast-top-right',
        preventDuplicates: true,
        progressBar: true
    }),
    NgItemLabelDirective,
    CommonModule,
    DragDropModule
],
  providers: [
    { provide: LOCALE_ID, useValue: 'es' },
    DatePipe
  ],
})
export class AppModule {

  constructor(private injector: Injector) {}

  ngDoBootstrap() {
    // LOGIN
    const loginEl = createCustomElement(LoginComponent, { injector: this.injector });
    if (!customElements.get('angular-login')) {
      customElements.define('angular-login', loginEl);
    }
    // REGISTER
    const registerEl = createCustomElement(RegisterComponent, { injector: this.injector });
    if (!customElements.get('angular-register')) {
      customElements.define('angular-register', registerEl);
    }
    // REGENERATE
    const regenerateEl = createCustomElement(RegenerateComponent, { injector: this.injector });
    if (!customElements.get('angular-regenerate')) {
      customElements.define('angular-regenerate', regenerateEl);
    }
    // HEADER
    const headerModalEl = createCustomElement(HeaderComponent, { injector: this.injector });
    if (!customElements.get('angular-header')) {
      customElements.define('angular-header', headerModalEl);
    }
    // HUELLAS MODAL
    const perfilHuellasModalEl = createCustomElement(HuellasModalComponent, { injector: this.injector });
    if (!customElements.get('angular-huellas-modal')) {
      customElements.define('angular-huellas-modal', perfilHuellasModalEl);
    }
    // VISITAS MODAL
    const perfilVisitasModalEl = createCustomElement(VisitasModalComponent, { injector: this.injector });
    if (!customElements.get('angular-visitas-modal')) {
      customElements.define('angular-visitas-modal', perfilVisitasModalEl);
    }
    // MENSAJES MODAL
    const perfilMensajesModalEl = createCustomElement(MensajesModalComponent, { injector: this.injector });
    if (!customElements.get('angular-mensajes-modal')) {
      customElements.define('angular-mensajes-modal', perfilMensajesModalEl);
    }
    // NOTIFICACIONES MODAL
    const perfilNotificacionesModalEl = createCustomElement(NotificacionesModalComponent, { injector: this.injector });
    if (!customElements.get('angular-notificaciones-modal')) {
      customElements.define('angular-notificaciones-modal', perfilNotificacionesModalEl);
    }
    // AMIGOS MODAL
    const perfilAmigosModalEl = createCustomElement(AmigosModalComponent, { injector: this.injector });
    if (!customElements.get('angular-amigos-modal')) {
      customElements.define('angular-amigos-modal', perfilAmigosModalEl);
    }
    // COMPARTIR MODAL
    const perfilCompartirModalEl = createCustomElement(CompartirModalComponent, { injector: this.injector });
    if (!customElements.get('angular-compartir-modal')) {
      customElements.define('angular-compartir-modal', perfilCompartirModalEl);
    }
    // AMIGOS
    const amigosEl = createCustomElement(AmigosComponent, { injector: this.injector });
    if (!customElements.get('angular-amigos')) {
      customElements.define('angular-amigos', amigosEl);
    }
    // QUIZAS CONOZCAS
    const quizasConozcasEl = createCustomElement(QuizasConozcasComponent, { injector: this.injector });
    if (!customElements.get('angular-quizas-conozcas')) {
      customElements.define('angular-quizas-conozcas', quizasConozcasEl);
    }
    // ULTIMOS PERFILES CONECTADOS
    const ultimosPerfilesEl = createCustomElement(UltimosPerfilesComponent, { injector: this.injector });
    if (!customElements.get('angular-ultimos-perfiles')) {
      customElements.define('angular-ultimos-perfiles', ultimosPerfilesEl);
    }
    // BOTONES HOME
    const botonesHomeEl = createCustomElement(BotonesHomeComponent, { injector: this.injector });
    if (!customElements.get('angular-botones-home')) {
      customElements.define('angular-botones-home', botonesHomeEl);
    }
    // PASEOS
    const paseosEl = createCustomElement(PaseosComponent, { injector: this.injector });
    if (!customElements.get('angular-paseos')) {
      customElements.define('angular-paseos', paseosEl);
    }
    // PASEO INFO
    const paseoInfoEl = createCustomElement(PaseoInfoComponent, { injector: this.injector });
    if (!customElements.get('angular-paseo-info')) {
      customElements.define('angular-paseo-info', paseoInfoEl);
    }
    // PASEO DETALLES
    const paseoDetallesEl = createCustomElement(PaseoDetallesComponent, { injector: this.injector });
    if (!customElements.get('angular-paseo-detalles')) {
      customElements.define('angular-paseo-detalles', paseoDetallesEl);
    }
    // MUROS
    const murosEl = createCustomElement(MurosComponent, { injector: this.injector });
    if (!customElements.get('angular-muros')) {
      customElements.define('angular-muros', murosEl);
    }
    // MURO FILTROS
    const muroFiltrosEl = createCustomElement(MuroFiltrosComponent, { injector: this.injector });
    if (!customElements.get('angular-muro-filtros')) {
      customElements.define('angular-muro-filtros', muroFiltrosEl);
    }
    // PERFIL
    const perfilEl = createCustomElement(PerfilComponent, { injector: this.injector });
    if (!customElements.get('angular-perfil')) {
      customElements.define('angular-perfil', perfilEl);
    }
    // MASCOTAS
    const mascotasEl = createCustomElement(MascotasComponent, { injector: this.injector });
    if (!customElements.get('angular-mascotas')) {
      customElements.define('angular-mascotas', mascotasEl);
    }
    // OPCIONES PERFIL
    const perfilOpcionesEl = createCustomElement(PerfilOpcionesComponent, { injector: this.injector });
    if (!customElements.get('angular-perfil-opciones')) {
      customElements.define('angular-perfil-opciones', perfilOpcionesEl);
    }
    // PERFIL PUBLICO
    const perfilPublicoEl = createCustomElement(PerfilPublicoComponent, { injector: this.injector });
    if (!customElements.get('angular-perfil-publico')) {
      customElements.define('angular-perfil-publico', perfilPublicoEl);
    }
    // RADAR
    const radarEl = createCustomElement(RadarComponent, { injector: this.injector });
    if (!customElements.get('angular-radar')) {
      customElements.define('angular-radar', radarEl);
    }
    // SALUD
    const saludEl = createCustomElement(SaludComponent, { injector: this.injector });
    if (!customElements.get('angular-salud-mascotas')) {
      customElements.define('angular-salud-mascotas', saludEl);
    }
    // ACCESOS RAPIDOS
    const accesosEl = createCustomElement(IguauAccesosComponent, { injector: this.injector });
    if (!customElements.get('angular-iguau-accesos')) {
      customElements.define('angular-iguau-accesos', accesosEl);
    }
    // BANNER BLOG
    const bannerBlogEl = createCustomElement(BannerBlogComponent, { injector: this.injector });
    if (!customElements.get('angular-banner-blog')) {
      customElements.define('angular-banner-blog', bannerBlogEl);
    }
    // COMO FUNCIONA
    const comoFuncionaEl = createCustomElement(ComoFuncionaComponent, { injector: this.injector });
    if (!customElements.get('angular-como-funciona')) {
      customElements.define('angular-como-funciona', comoFuncionaEl);
    }
    // BANNER HOME
    const bannerHomeEl = createCustomElement(BannerHomeComponent, { injector: this.injector });
    if (!customElements.get('angular-banner-home')) {
      customElements.define('angular-banner-home', bannerHomeEl);
    }
    // FOTOS PRIVADAS
    const fotosPrivadasEl = createCustomElement(FotosPrivadasComponent, { injector: this.injector });
    if (!customElements.get('angular-fotos-privadas')) {
      customElements.define('angular-fotos-privadas', fotosPrivadasEl);
    }
    // FOOTER
    const footerEl = createCustomElement(FooterComponent, { injector: this.injector });
    if (!customElements.get('angular-footer')) {
      customElements.define('angular-footer', footerEl);
    }
  }
}
